module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierdaCargador-ap-16cf30ed.png";